
const ExternalProductGuids = {
    hm3AllStakes: "df22eb12-f490-11e7-9756-0242ac130004",
    hm3SmallStakes: "df254920-f490-11e7-bf15-0242ac130004",
    hm3Trial: "bd1e49f0-0f96-11e8-946b-0242ac130005",
    hm3Freemium: "bd1f8b3a-0f96-11e8-99cb-0242ac130005",
    hm3Maintenance: "6fc72036-f48f-11e7-8fb4-0242ac130004",

    omahaAllStakes: "df2545a6-f490-11e7-968f-0242ac130004",
    omahaSmallStakes: "df254c2c-f490-11e7-891e-0242ac130004",
    omahaTrial:  "bd1f8cde-0f96-11e8-9fed-0242ac130005",
    omahaFreemium: "bd1f8e00-0f96-11e8-8eb6-0242ac130005",
    omahaMaintenance: "dc6da1bc-f492-11e7-ae33-0242ac130004",


    purchaseAddHm3AllToOm3: "7197c930-b6c1-11e8-bb9f-0242ac170002", //HM3-ALL-ADD
    purchaseAddHm3SmallToOm3: "7197cc45-b6c1-11e8-bb9f-0242ac170002", //HM3-SS-ADD
    purchaseAddHm3AllToOm3Small: "81983108-ba86-11e8-bb9f-0242ac170002", // HM3-ALL-ADD-OM3-SS
    purchaseAddHm3SmallToOm3Small: "2f99bf1d-ba87-11e8-bb9f-0242ac170002",

    purchaseAddOm3AllToHm3: "7197cbd8-b6c1-11e8-bb9f-0242ac170002",
    purchaseAddOm3SmallToHm3: "7197cc84-b6c1-11e8-bb9f-0242ac170002",
    purchaseAddOm3AllToHm3Small: "8198310c-ba86-11e8-bb9f-0242ac170002",
    purchaseAddOm3SmallToHm3Small: "2f99bf20-ba87-11e8-bb9f-0242ac170002",

    purchaseUpgradeHm3SmallToHm3All: "05322d69-b6c1-11e8-bb9f-0242ac170002",
    purchaseUpgradeHm3SmallToHm3All_Om3All: "d377a54f-ba87-11e8-bb9f-0242ac170002", //HM3-SS-UPG-OM3-ALL
    purchaseUpgradeHm3SmallToHm3All_Om3Small: "d377a555-ba87-11e8-bb9f-0242ac170002",

    purchaseUpgradeOm3SmallToOm3All: "05322f3a-b6c1-11e8-bb9f-0242ac170002",
    purchaseUpgradeOm3SmallToOm3All_Hm3All: "08b446e6-ba88-11e8-bb9f-0242ac170002",
    purchaseUpgradeOm3SmallToOm3All_Hm3Small: "08b446ed-ba88-11e8-bb9f-0242ac170002",

    purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All: "ca7d6e07-18ba-11eb-baa8-0242ac150003",

    // HM3 All Stakes + Omaha All Stakes
    purchaseBothAll: "8f9c23d2-f491-11e7-aaaf-0242ac130004",
    // HM3 small stakes + omaha small stakes (at this time, not used)
    purchaseBothSmall: "8f9c24f4-f491-11e7-b6fa-0242ac130004",

    initialPurchaseHm3Small: "8f9c2206-f491-11e7-9936-0242ac130004",
    initialPurchaseHm3All: "8f9ae968-f491-11e7-94f3-0242ac130004",
    initialPurchaseOmahaSmall: "8f9c272e-f491-11e7-b44b-0242ac130004",
    initialPurchaseOmahaAll: "8f9c262a-f491-11e7-97d1-0242ac130004",


    renewalHm3AAll_Om3All: "05c40b8e-f7c4-11e8-82dc-0242ac150002",
    renewalHm3Small_Om3Small: "05c41a34-f7c4-11e8-8adb-0242ac150002",
    renewalHm3All_Om3Small: "05c4257e-f7c4-11e8-9dc9-0242ac150002",
    renewalHm3Small_Om3All: "05c42b78-f7c4-11e8-b290-0242ac150002",

    renewalHm3All: "05c4324e-f7c4-11e8-8657-0242ac150002",
    renewalHm3Small: "05c439ec-f7c4-11e8-8b77-0242ac150002",
    renewalOm3All: "05c44112-f7c4-11e8-bbc8-0242ac150002",
    renewalOm3Small: "05c44982-f7c4-11e8-b14d-0242ac150002",
};

export default  {

    hm3AllStakes: ExternalProductGuids.hm3AllStakes,
    hm3SmallStakes: ExternalProductGuids.hm3SmallStakes,
    hm3Trial: ExternalProductGuids.hm3Trial,
    hm3Freemium: ExternalProductGuids.hm3Freemium,
    hm3Maintenance: ExternalProductGuids.hm3Maintenance,

    omahaAllStakes: ExternalProductGuids.omahaAllStakes,
    omahaSmallStakes: ExternalProductGuids.omahaSmallStakes,
    omahaTrial:  ExternalProductGuids.omahaTrial,
    omahaFreemium: ExternalProductGuids.omahaFreemium,
    omahaMaintenance: ExternalProductGuids.omahaMaintenance,



    // HM3 All Stakes + Omaha All Stakes
    purchaseBothAll: [
        ExternalProductGuids.purchaseBothAll,
        ExternalProductGuids.purchaseAddHm3AllToOm3,
        ExternalProductGuids.purchaseAddOm3AllToHm3,
    ],
    purchaseBothAllIncludeUpgradeAllCombo: [
        ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,
        ExternalProductGuids.purchaseBothAll,
        ExternalProductGuids.purchaseAddHm3AllToOm3,
        ExternalProductGuids.purchaseAddOm3AllToHm3,
    ],
    // HM3 small stakes + omaha small stakes
    purchaseBothSmall: [
        ExternalProductGuids.purchaseBothSmall,
        ExternalProductGuids.purchaseAddHm3SmallToOm3Small,
        ExternalProductGuids.purchaseAddOm3SmallToHm3Small,
    ],

    purchaseBuyHm3Small: [
        ExternalProductGuids.initialPurchaseHm3Small,
        ExternalProductGuids.purchaseAddHm3SmallToOm3,
        ExternalProductGuids.purchaseAddHm3SmallToOm3Small,
        ExternalProductGuids.renewalHm3Small,
     ],

    purchaseBuyHm3All: [
        ExternalProductGuids.initialPurchaseHm3All,
        ExternalProductGuids.purchaseAddHm3AllToOm3,
        ExternalProductGuids.purchaseAddHm3AllToOm3Small,
        ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All,
        ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3All,
        ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3Small,
        ExternalProductGuids.renewalHm3All,
    ],

    purchaseBuyOm3Small: [
        ExternalProductGuids.initialPurchaseOmahaSmall,
        ExternalProductGuids.purchaseAddOm3SmallToHm3,
        ExternalProductGuids.purchaseAddOm3SmallToHm3Small,
        ExternalProductGuids.renewalOm3Small,
        ],
    purchaseBuyOm3All: [
        ExternalProductGuids.initialPurchaseOmahaAll,
        ExternalProductGuids.purchaseAddOm3AllToHm3,
        ExternalProductGuids.purchaseAddOm3AllToHm3Small,
        ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All,
        ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3All,
        ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3Small,
        ExternalProductGuids.renewalOm3All,
    ],

    
    purchaseUpgradeHm3Small: [
        ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,
        ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All,
        ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3All,
        // Important: allowing this would mess up showing a single combo on the "Select Products" page
        // (since at this time - Oct 30,2020 - we only allow showing the highest available combo)
        //ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3Small,
    ],
    purchaseUpgradeOm3Small: [
        ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,
        ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All,
        ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3All,
        // Important: allowing this would mess up showing a single combo on the "Select Products" page
        // (since at this time - Oct 30,2020 - we only allow showing the highest available combo)
        //ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3Small,
    ],

    renewHm3Both:[
        ExternalProductGuids.renewalHm3AAll_Om3All,
        ExternalProductGuids.renewalHm3All_Om3Small,
        ExternalProductGuids.renewalHm3Small_Om3All,
        ExternalProductGuids.renewalHm3Small_Om3Small
    ],
    renewHm3Single: [
        ExternalProductGuids.renewalHm3All,
        ExternalProductGuids.renewalHm3Small
    ],
    renewOm3Both: [
        ExternalProductGuids.renewalHm3AAll_Om3All,
        ExternalProductGuids.renewalHm3All_Om3Small,
        ExternalProductGuids.renewalHm3Small_Om3All,
        ExternalProductGuids.renewalHm3Small_Om3Small
    ],
    renewOm3Single: [
        ExternalProductGuids.renewalOm3All,
        ExternalProductGuids.renewalOm3Small
    ],

    renewHm3:[
        ExternalProductGuids.renewalHm3AAll_Om3All,
        ExternalProductGuids.renewalHm3All_Om3Small,
        ExternalProductGuids.renewalHm3Small_Om3All,
        ExternalProductGuids.renewalHm3Small_Om3Small,
        ExternalProductGuids.renewalHm3All,
        ExternalProductGuids.renewalHm3Small
    ],
    renewOm3: [
        ExternalProductGuids.renewalHm3AAll_Om3All,
        ExternalProductGuids.renewalHm3All_Om3Small,
        ExternalProductGuids.renewalHm3Small_Om3All,
        ExternalProductGuids.renewalHm3Small_Om3Small,
        ExternalProductGuids.renewalOm3All,
        ExternalProductGuids.renewalOm3Small
    ],

    renewHm3Small:[
        ExternalProductGuids.renewalHm3Small_Om3All,
        ExternalProductGuids.renewalHm3Small_Om3Small,
        ExternalProductGuids.renewalHm3Small
    ],
    renewOm3Small: [
        ExternalProductGuids.renewalHm3All_Om3Small,
        ExternalProductGuids.renewalHm3Small_Om3Small,
        ExternalProductGuids.renewalOm3Small
    ],









    upgradeHm3ToComboSmall: [
        ExternalProductGuids.purchaseAddOm3SmallToHm3Small,
    ],
    upgradeOm3ToComboSmall: [
        ExternalProductGuids.purchaseAddHm3SmallToOm3Small,
    ],

    upgradeHm3ToComboAll: [
        //ExternalProductGuids.initialPurchaseOmahaAll,
        //ExternalProductGuids.purchaseAddOm3AllToHm3,
        //ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3All,
        //ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3Small,
        ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,
        ExternalProductGuids.purchaseBothAll,
    ],
    upgradeOm3ToComboAll: [
        //ExternalProductGuids.initialPurchaseHm3All,
        //ExternalProductGuids.purchaseAddHm3AllToOm3,
        //ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3All,
        //ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3Small,
        ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,
        ExternalProductGuids.purchaseBothAll,
    ],










    buyGuid:[
        ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,
        ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All,
        ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3All,
        ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3Small,
        ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All,
        ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3All,
        ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3Small,

        ExternalProductGuids.purchaseAddHm3AllToOm3,
        ExternalProductGuids.purchaseAddHm3AllToOm3Small,
        ExternalProductGuids.purchaseAddHm3SmallToOm3,
        ExternalProductGuids.purchaseAddHm3SmallToOm3Small,
        ExternalProductGuids.purchaseAddOm3AllToHm3,
        ExternalProductGuids.purchaseAddOm3AllToHm3Small,
        ExternalProductGuids.purchaseAddOm3SmallToHm3,
        ExternalProductGuids.purchaseAddOm3SmallToHm3Small,

        ExternalProductGuids.initialPurchaseHm3All,
        ExternalProductGuids.initialPurchaseHm3Small,
        ExternalProductGuids.initialPurchaseOmahaAll,
        ExternalProductGuids.initialPurchaseOmahaSmall,

        ExternalProductGuids.renewalHm3AAll_Om3All,
        ExternalProductGuids.renewalHm3All,
        ExternalProductGuids.renewalHm3All_Om3Small,
        ExternalProductGuids.renewalHm3Small,
        ExternalProductGuids.renewalHm3Small_Om3All,
        ExternalProductGuids.renewalHm3Small_Om3Small,
        ExternalProductGuids.renewalOm3All,
        ExternalProductGuids.renewalOm3Small,

        ExternalProductGuids.hm3AllStakes,
        ExternalProductGuids.hm3SmallStakes,
        ExternalProductGuids.omahaAllStakes,
        ExternalProductGuids.omahaSmallStakes,
    ],


    buyHm3Guid: [
        ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,
        ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All,
        ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3All,
        ExternalProductGuids.purchaseUpgradeHm3SmallToHm3All_Om3Small,

        ExternalProductGuids.purchaseAddHm3AllToOm3,
        ExternalProductGuids.purchaseAddHm3AllToOm3Small,
        ExternalProductGuids.purchaseAddHm3SmallToOm3,
        ExternalProductGuids.purchaseAddHm3SmallToOm3Small,

        ExternalProductGuids.initialPurchaseHm3All,
        ExternalProductGuids.initialPurchaseHm3Small,

        ExternalProductGuids.hm3AllStakes,
        ExternalProductGuids.hm3SmallStakes,

        ExternalProductGuids.renewalHm3All,
        ExternalProductGuids.renewalHm3Small,

        // note: user can have biggest discount when buying a combo
        ExternalProductGuids.purchaseBothAll,
        ExternalProductGuids.purchaseBothSmall,
    ],

    buyOmahaGuid: [
        ExternalProductGuids.purchaseUpgradeOm3SmallHm3Small_ToOm3All_Hm3All,
        ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All,
        ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3All,
        ExternalProductGuids.purchaseUpgradeOm3SmallToOm3All_Hm3Small,

        ExternalProductGuids.purchaseAddOm3AllToHm3,
        ExternalProductGuids.purchaseAddOm3AllToHm3Small,
        ExternalProductGuids.purchaseAddOm3SmallToHm3,
        ExternalProductGuids.purchaseAddOm3SmallToHm3Small,

        ExternalProductGuids.initialPurchaseOmahaAll,
        ExternalProductGuids.initialPurchaseOmahaSmall,

        ExternalProductGuids.renewalOm3All,
        ExternalProductGuids.renewalOm3Small,

        ExternalProductGuids.omahaAllStakes,
        ExternalProductGuids.omahaSmallStakes,

        // note: user can have biggest discount when buying a combo
        ExternalProductGuids.purchaseBothAll,
        ExternalProductGuids.purchaseBothSmall,
    ],

    smallGuids: [

        ExternalProductGuids.purchaseAddHm3SmallToOm3,
        ExternalProductGuids.purchaseAddHm3SmallToOm3Small,
        ExternalProductGuids.purchaseAddOm3SmallToHm3,
        ExternalProductGuids.purchaseAddOm3SmallToHm3Small,

        ExternalProductGuids.initialPurchaseHm3Small,
        ExternalProductGuids.initialPurchaseOmahaSmall,

        ExternalProductGuids.hm3SmallStakes,
        ExternalProductGuids.omahaSmallStakes,

        ExternalProductGuids.purchaseBothSmall,
    ],

    comboGuids: [
        ExternalProductGuids.purchaseBothAll,
        ExternalProductGuids.purchaseBothSmall,
    ],

    renewals:[
        ExternalProductGuids.renewalHm3AAll_Om3All,
        ExternalProductGuids.renewalHm3Small_Om3Small ,
        ExternalProductGuids. renewalHm3All_Om3Small,
        ExternalProductGuids. renewalHm3Small_Om3All,
    
        ExternalProductGuids. renewalHm3All,
        ExternalProductGuids. renewalHm3Small,
        ExternalProductGuids. renewalOm3All,
        ExternalProductGuids. renewalOm3Small,    
    ],


    renewalHm3AAll_Om3All: ExternalProductGuids.renewalHm3AAll_Om3All,
    renewalHm3Small_Om3Small: ExternalProductGuids.renewalHm3Small_Om3Small ,
    renewalHm3All_Om3Small:  ExternalProductGuids. renewalHm3All_Om3Small,
    renewalHm3Small_Om3All:  ExternalProductGuids. renewalHm3Small_Om3All,

    renewalHm3All:  ExternalProductGuids. renewalHm3All,
    renewalHm3Small:  ExternalProductGuids. renewalHm3Small,
    renewalOm3All:  ExternalProductGuids. renewalOm3All,
    renewalOm3Small:  ExternalProductGuids. renewalOm3Small,

}


// WEBPACK FOOTER //
// ./src/api/productGuids.js